export default "__VITE_ASSET__CrIP584D__"